import React from "react";

const Contact = ({ contactSection }) => {
  if (!contactSection) return null;

  const { title, intro_text, contact_list = [], iframe_src } = contactSection;

  return (
    <section className="pb_80 pt_80">
      <div className="container">
        <div className="row d-flex justify-content-center ">
          <div className="col-md-4">
            <div className="contact-details">
              <h2>{title}</h2>
              <p>{intro_text}</p>

              {contact_list.map((item, index) => (
                <div className="contact-info-item" key={index}>
                  <i className={`fa ${item.icon_class} contact-icon`}></i>
                  <span>
                    {item.link_prefix ? (
                      <a
                        href={`${item.link_prefix}${item.value}`}
                        className="email-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.value}
                      </a>
                    ) : (
                      item.value
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-4">
            <div className="map-container">
              <iframe
                src={iframe_src}
                title="Chettinad Health City Location"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
